<template>
  <div class="upload">
    <div 
      class="upload-cancel" 
      v-if="global.uploadStore.loading"
    >
		<el-button type="warning" size="mini" @click="()=>global.cancelUploadFile()">取消上传</el-button>
	</div>
  <template  v-for="item in uploadList">
    <el-upload
      :key="item.key"
      drag
      action="#"
      class="upload-box mb16"
      :http-request="(data)=>handleHttpRequest(data, item.configList)"
      :show-file-list="false"
      v-if="item.configList.length"
      multiple>
      <div class="upload-tip">
          <div class="upload-title pt10">{{item.title}}</div>
          <div class="upload-text mt10">您可点击此处 或 拖拽素材至此进行批量上传素材</div>
          <div 
              v-for="item in item.configList"
              :key="item.id"
              class="fiter-item mt20"
          > {{ item.format_text }} </div>
        </div>
    </el-upload>
  </template>
    
  </div>
</template>

<script>
import _ from 'lodash';
// import { FILE_TYPE } from '../constant'
export default {
	inject:[ 'global' ],
	data() {
		return {}
	},
	computed: {
		uploadList() {
      
      // 
			return [
				{
					key: 1,
					configList: this.global.fileConfigList,
					title: '上传图片/视频素材'
				},
			]
		}
	},
	methods: {
		handleHttpRequest({ file }, configList) {
			file.key = this.global.currentKey;
			this.global.handleUploadFile(file, { configList })
		},
	}
}
</script>

<style lang="scss" scoped>
.upload ::v-deep {
    .el-upload,.el-upload-dragger {
        width: 100%;
    }
    .el-upload-dragger {
        height: auto;
        padding-bottom: 40px;
    }
} 
.upload-tip {
   font-size: 12px;
   color: #606266;
   padding: 8px 0;
   .upload-title {
    font-size: 14px;
    font-weight: bold;
   }
  //  .upload-text {

  //  }
//    .fiter-item {
//    }
}
.upload-cancel {
    position: absolute;
    top: 6px;
    left: 220px;
    z-index: 9;
}
</style>